(ns
  frontend.ui.component.lp-portal.report.body.private-equity.holding.company-exit.pdf.view
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.card.pdf.view :refer [card]]
   [frontend.ui.component.lp-portal.column.pdf.view
    :refer [column columns columns-2-to-1]]
   [frontend.ui.component.lp-portal.page.pdf.view
    :as page]
   [frontend.ui.component.lp-portal.stacked-text-group.pdf.view
    :refer [stacked-text-group]]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]))

(defn overview-pages
  [report-data]
  [(page/page
    (page/third-column-background)
    (page/page-title {:page-title
                      (str (:holding-name report-data) " - exited investment")
                      :toc-item   true})
    (columns-2-to-1
     (card
      "Case Overview"
      (text-content/rich-content (->> report-data
                                      :case-overview-text
                                      :rich-content)))
     {:margin [0 15 0 0]
      :stack  (concat (->> report-data
                           :recent-exits-figures
                           :figures
                           (map
                            (fn [[label value]]
                              (stacked-text-group label value))))
                      [{:margin [0 15 0 0]
                        :stack  [(text-content/optional-footer (-> report-data
                                                                   :recent-exits-figures))]}])}))
   (page/page
    (page/page-title {:page-title (:holding-name report-data)})
    (column/column
     (card
      "Financials"
      {:svg   (chart-view/chart-svg "highcharts"
                                    (potpuri/deep-merge
                                     (-> report-data
                                         :financials
                                         :figures)
                                     {:chart {:width  800
                                              :height 360}}))
       :width page/page-width-without-margins}
      (text-content/optional-footer (:financials report-data)) ; is this ever used?
     )))])

(defn holding-pages
  [report-data]
  (overview-pages report-data))
